import { HubertButton } from 'components/HubertUI/HubertButton';
import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

interface CloseQuestionProps extends ComponentProps<typeof HubertButton> {
  buttonText?: string;
  onCancel?: () => void;
}

export const CloseQuestion = ({ buttonText, onCancel, ...props }: CloseQuestionProps) => {
  const { t } = useTranslation('Questionsv2');
  return (
    <HubertButton
      {...props}
      onClick={() => {
        if (onCancel) {
          onCancel();
        }
      }}
    >
      {buttonText ?? t('closeQuestion.defaultButton')}
    </HubertButton>
  );
};
